import { useMutation } from '@tanstack/react-query';

import register from '../../api/mutations/register';
import useErrorHandler from '../useErrorHandler';

const useRegister = () => {
  const { handleError } = useErrorHandler();

  const { mutateAsync: registerUser, isPending } = useMutation({
    mutationKey: ['register'],
    mutationFn: (data: { name: string; email: string; password: string; businessName: string }) =>
      register(data),
    // onSuccess: (data) => {
    //   dispatch(
    //     registerSuccess({
    //       tokens: {
    //         accessToken: data.access_token,
    //         refreshToken: data.refresh_token,
    //       },
    //       user: {
    //         _id: data._id,
    //         country: data.country,
    //         email: data.email,
    //         name: data.name,
    //         role: data.role,
    //       },
    //     })
    //   );
    // },
    onError: (error) => {
      handleError(error);
    },
  });

  return { registerUser, isPending };
};

export default useRegister;
